import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bulgari-button',
  templateUrl: './bulgari-button.component.html',
  styleUrls: ['./bulgari-button.component.scss']
})
export class BulgariButtonComponent {
  @Input() text!: string;
  @Input() type!: string;
  @Input() disabled!: boolean;
  @Input() full!: boolean;
  @Input() customStyle: any;
  constructor() { }

}
